import { render, staticRenderFns } from "./SetGeoTargeting.vue?vue&type=template&id=b7f642ec&"
import script from "./SetGeoTargeting.vue?vue&type=script&lang=js&"
export * from "./SetGeoTargeting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports